import React from "react";

import { Card } from "@/components/flowbite/card";
import Typography from "@/components/flowbite/typography/typography";
import { EmStudentsIcon } from "@/components/icons-lib";
import { formatNumber } from "@/shared/utils/format-number.util";

import { SectionTitle } from "./section-title";
import { STUDENT_CLUSTER_SUMMARY_DICTIONARY } from "./student-cluster-summary.constants";

interface StudentClusterSummaryProps {
  studentsCount: number;
}

const StudentClusterSummaryComponent: React.FC<StudentClusterSummaryProps> = ({
  studentsCount,
}) => {
  return (
    <div>
      <SectionTitle title="Summary" />

      <div className="mt-2">
        <Card className="flex flex-col gap-2 border-none bg-gray-100 p-2">
          <div className="flex gap-2">
            <Typography.H5
              className="flex-1"
              colorShade={500}
            >
              {formatNumber(studentsCount)}
            </Typography.H5>

            <EmStudentsIcon />
          </div>

          <div>
            <Typography.BodySRegular colorShade={400}>
              {STUDENT_CLUSTER_SUMMARY_DICTIONARY.students}
            </Typography.BodySRegular>
          </div>
        </Card>
      </div>
    </div>
  );
};

export const StudentClusterSummary = React.memo(StudentClusterSummaryComponent);
